/** Figuras rítmicas didácticas (compás 4/4, rejilla corchea). */

export type RhythmFigureId =
  | 'negra'
  | 'blanca'
  | 'corchea_doble'
  | 'cuartina'
  | 'silencio_negra'
  | 'silencio_corchea'
  | 'silencio_blanca';

export type RhythmAtomId = 'negra' | 'corchea' | 'semicorchea' | 'blanca' | RhythmFigureId;

export interface RhythmAtom {
  abcTok: string;
  atomId: RhythmAtomId;
  isRest: boolean;
}

export function durationUnitsFromAbcTok(token: string): number | null {
  const t = String(token || '');
  const m = t.match(/^[Cz](?:(\d+)(?:\/(\d+))?|\/(\d+)?|(\/\/))?$/);
  if (!m) return null;
  const intNum = m[1] ? Number(m[1]) : null;
  const intDen = m[2] ? Number(m[2]) : null;
  const onlyDen = m[3] != null && m[3] !== '' ? Number(m[3]) : null;
  const doubleSlash = !!m[4];
  if (intNum !== null && Number.isFinite(intNum)) {
    if (intDen !== null && Number.isFinite(intDen) && intDen !== 0) return intNum / intDen;
    return intNum;
  }
  if (doubleSlash) return 0.25;
  if (t.endsWith('/')) return 0.5;
  if (onlyDen !== null && Number.isFinite(onlyDen) && onlyDen !== 0) return 1 / onlyDen;
  return 1;
}

export function expandFigure(figura: RhythmFigureId): RhythmAtom[] {
  switch (figura) {
    case 'corchea_doble':
      return [
        { abcTok: 'C', atomId: 'corchea', isRest: false },
        { abcTok: 'C', atomId: 'corchea', isRest: false },
      ];
    case 'cuartina':
      return [
        { abcTok: 'C/', atomId: 'semicorchea', isRest: false },
        { abcTok: 'C/', atomId: 'semicorchea', isRest: false },
        { abcTok: 'C/', atomId: 'semicorchea', isRest: false },
        { abcTok: 'C/', atomId: 'semicorchea', isRest: false },
      ];
    case 'silencio_negra':
      return [{ abcTok: 'z2', atomId: 'silencio_negra', isRest: true }];
    case 'silencio_corchea':
      return [{ abcTok: 'z', atomId: 'silencio_corchea', isRest: true }];
    case 'silencio_blanca':
      return [{ abcTok: 'z4', atomId: 'silencio_blanca', isRest: true }];
    case 'blanca':
      return [{ abcTok: 'C4', atomId: 'blanca', isRest: false }];
    case 'negra':
    default:
      return [{ abcTok: 'C2', atomId: 'negra', isRest: false }];
  }
}

export function figureLabel(figura: RhythmFigureId): string {
  switch (figura) {
    case 'blanca':
      return 'Blanca';
    case 'negra':
      return 'Negra';
    case 'corchea_doble':
      return 'Corchea doble';
    case 'cuartina':
      return 'Cuartina';
    case 'silencio_negra':
      return 'Silencio (negra)';
    case 'silencio_corchea':
      return 'Silencio (corchea)';
    case 'silencio_blanca':
      return 'Silencio (blanca)';
    default:
      return 'Figura';
  }
}

export function isRestToken(token: string): boolean {
  return String(token || '').startsWith('z');
}

export function figureShortLabel(figura: RhythmFigureId): string {
  switch (figura) {
    case 'silencio_negra':
    case 'silencio_corchea':
    case 'silencio_blanca':
      return 'Silencio';
    default:
      return figureLabel(figura);
  }
}
